/**
 * The live site page as one page (replaces the five tabs). Left column:
 * preview, drop zone, tests of this site, versions, visits. Right column:
 * address and custom domain, then settings. Each block is a titled section
 * with an id, so the old tab URLs (/versions, /domain, /analytics, /settings)
 * still work: AeroSiteDetail scrolls to the matching section.
 *
 * It only arranges the existing tab components; their logic is unchanged.
 */
import React from 'react';
import SiteOverviewTab from './tabs/SiteOverviewTab';
import SitePrototypeTab from './tabs/SitePrototypeTab';
import SiteVersionsTab from './tabs/SiteVersionsTab';
import SiteDomainTab from './tabs/SiteDomainTab';
import SiteAnalyticsTab from './tabs/SiteAnalyticsTab';
import SiteSettingsTab from './tabs/SiteSettingsTab';

export const SECTION_IDS = {
  overview: 'site-preview',
  prototype: 'site-prototype',
  versions: 'site-versions',
  domain: 'site-domain',
  analytics: 'site-visits',
  settings: 'site-settings',
};

function Section({ id, title, hint, children }) {
  return (
    <section id={id} className="aero-sd-sec">
      <div className="aero-sd-sec-head">
        <h3 className="aero-sd-sec-title">{title}</h3>
        {hint && <span className="aero-sd-sec-hint">{hint}</span>}
      </div>
      {children}
    </section>
  );
}

// `visits` swaps the Analytics block (the style guide has no live visits).
export default function SiteOnePage({ ctx, isFigma, visits = null }) {
  return (
    <div className="aero-sd-onepage">
      <div className="aero-sd-main">
        <section id={SECTION_IDS.overview} className="aero-sd-sec aero-sd-sec-first">
          <SiteOverviewTab {...ctx} />
        </section>
        {isFigma ? (
          <Section id={SECTION_IDS.prototype} title="Prototype">
            <SitePrototypeTab {...ctx} />
          </Section>
        ) : (
          <Section id={SECTION_IDS.versions} title="Versions">
            <SiteVersionsTab {...ctx} />
          </Section>
        )}
        <Section id={SECTION_IDS.analytics} title="Visits">
          {visits || <SiteAnalyticsTab {...ctx} />}
        </Section>
      </div>
      <aside className="aero-sd-side">
        <Section id={SECTION_IDS.domain} title="Address and domain">
          <SiteDomainTab {...ctx} />
        </Section>
        <Section id={SECTION_IDS.settings} title="Settings">
          <SiteSettingsTab {...ctx} />
        </Section>
      </aside>
    </div>
  );
}
